import { render, staticRenderFns } from "./SystemComponent.vue?vue&type=template&id=397ef608&scoped=true"
import script from "./SystemComponent.vue?vue&type=script&lang=js"
export * from "./SystemComponent.vue?vue&type=script&lang=js"
import style0 from "./SystemComponent.vue?vue&type=style&index=0&id=397ef608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ef608",
  null
  
)

export default component.exports